import type { OrderListItem } from 'ClientPortal/src/pages/Orders/OrderList/OrderListPageContent.data'
import { useIamContext } from 'ClientPortal/src/context/IAmContext'
import { usePatchOrder } from 'ClientPortal/src/api/Queries/orders'
import { Operation } from 'fast-json-patch'

export const useOrderObserverToggleData = ({ order, onSuccess }: { order: OrderListItem; onSuccess?: () => void }) => {
    const { user } = useIamContext()

    const useOrderObserverTogglePatch = (orderId: string) => {
        const { patchOrder } = usePatchOrder({ orderId, onSuccess, shouldDelayInvalidation: true })

        const toggleObserver = ({
            isObserving,
            currentUserObserverIndex,
            currentUserUuid,
        }: {
            isObserving: boolean
            currentUserObserverIndex: number
            currentUserUuid: string
        }) => {
            const operations: Operation[] = isObserving
                ? [
                      {
                          op: 'remove',
                          path: `/observers/${currentUserObserverIndex}`,
                      },
                  ]
                : [
                      {
                          op: 'add',
                          path: `/observers/-`,
                          value: currentUserUuid,
                      },
                  ]

            patchOrder(operations)
        }

        return { toggleObserver }
    }

    const { toggleObserver } = useOrderObserverTogglePatch(order.uuid)

    return { user, toggleObserver }
}
